import { TooltipV3 } from "src/components/TooltipV3/TooltipV3.tsx";

import { ColumnGroupingCell } from "src/components/DataGrid/product/ColumnGroupingCell.tsx";
import { useTranslation } from "react-i18next";
import { getResourceFieldTranslation } from "src/system/getResourceFieldOptions.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import { ProductType } from "@exonn/js-sdk";

export function SingleProductGroupingCell() {
  const { t } = useTranslation();
  return (
    <TooltipV3
      delayDuration={500}
      content={getResourceFieldTranslation({
        t,
        resource: ResourceEnum.Product,
        type: "option_label",
        field: "type",
        value: ProductType.SINGLE,
      })}
      contentProps={{ align: "start" }}
    >
      <ColumnGroupingCell>
        <span className={"icon-20-single"} />
      </ColumnGroupingCell>
    </TooltipV3>
  );
}
